import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

// TODO: Cambiar a Skeleton
const FingoTableLoader = () => <CircularProgress />;

export default FingoTableLoader;
